/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */

import MIMEType from 'whatwg-mimetype';

export async function fetchGetBody(response: Response, responseType): Promise<any> {
    const responseClone = response.clone();

    if (responseClone.status > 399) {
        const type = MIMEType.parse(response.headers.get('Content-Type'));
        if (type.essence === 'application/json') {
            responseType = 'json';
        } else if (type.type === 'text') {
            responseType = 'text';
        }
    }

    switch (responseType) {
        case 'json':
            return await responseClone.json();
        case 'text':
            return await responseClone.text();
        case 'arraybuffer':
            return await responseClone.arrayBuffer();
        case 'blob':
            return await responseClone.blob();
        default:
            throw new Error('Request has invalid requestType');
    }
}
